export class RewardTypes {
    public static ITEM = 'ITEM';
    public static DOLLAR = 'DOLLAR';
}
